import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="#EAEBEC" d="M8 8h4L7 3 2 8h4v12h2V8z"/>
    <path fill="#34CEFF" d="M22 16l-5 5-5-5h4V4h2v12h4z"/>
  </SvgIcon>
);